module.exports = __webpack_public_path__ + "media/בכה.f0206364.mp3";